import React from 'react';
import { GiveawayView } from './GiveawayView';
import { useGiveaway } from './hooks/useGiveaway/useGiveaway';
export const GiveawayContainer = () => {
    const { giveaway } = useGiveaway();
    return React.createElement(GiveawayView, { ...giveaway });
};
export default GiveawayContainer; // React.lazy
